module.exports = __webpack_public_path__ + "img/young-crazy-hipster.e5dd10bc.png";